/**
 * Interaction state elements shared by design-system components.
 * Source of truth: Pangea Galapagos UI Design System — Beta
 * https://www.figma.com/design/Orc6uUodQaoXep59CGaUNw
 */

export const states = {
  borderWidth: {
    default: 1,
    selected: 2,
  },
  opacity: {
    enabled: 1,
    disabled: 0.5,
  },
} as const;

export type States = typeof states;
